import { render, staticRenderFns } from "./ManuimView.vue?vue&type=template&id=64080181&"
import script from "./ManuimView.vue?vue&type=script&lang=js&"
export * from "./ManuimView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports